

















import { Component, Vue } from 'vue-property-decorator';
import EditableText from '@/components/common/EditableText.vue';

@Component({
  components: {
    EditableText,
  },
})
export default class UnitTestBase extends Vue {
  private text: string = 'テスト文字列';
}
